import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    notificationList: [],
    userID: [],
    notificationID: [],
    message: '',
    errors: ''
};

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        getUserNotifications: (state, action) => {
            state.userID = action.payload;
        },
        setUserNotifications: (state, action) => {
            state.notificationList = action.payload;
        },
        getUserNotificationsSuccessMessage: (state, action) => {
            state.isLoading = false;
            state.message = action.payload;
        },
        getUserNotificationsErrorMessage: (state, action) => {
            state.isLoading = false;
            state.errors = action.payload;
        },

        deleteUserNotification: (state, action) => {
            state.notificationID = action.payload;
        },
        deleteUserNotificationsSuccessMessage: (state, action) => {
            const payload = action.payload;
            state.message =
                typeof payload === 'object' && payload !== null
                    ? payload.message || ''
                    : payload || '';
            const deletedId =
                typeof payload === 'object' && payload !== null ? payload.deletedId : null;
            if (deletedId != null) {
                state.notificationList = state.notificationList.filter(
                    (item) => item?.id !== deletedId && item?.Id !== deletedId
                );
            }
        },
        deleteUserNotificationsErrorMessage: (state, action) => {
            state.errors = action.payload;
        },
        reviewSkillChangeNotification: (state) => {
            state.isLoading = true;
            state.errors = '';
        },
        reviewSkillChangeNotificationSuccess: (state, action) => {
            state.isLoading = false;
            state.message = action.payload || '';
        },
        reviewSkillChangeNotificationFailure: (state, action) => {
            state.isLoading = false;
            state.errors = action.payload;
        },
    }
});

export const {
    getUserNotifications,
    getUserNotificationsSuccessMessage,
    getUserNotificationsErrorMessage,
    setUserNotifications,
    deleteUserNotification,
    deleteUserNotificationsSuccessMessage,
    deleteUserNotificationsErrorMessage,
    reviewSkillChangeNotification,
    reviewSkillChangeNotificationSuccess,
    reviewSkillChangeNotificationFailure,
} = notificationSlice.actions;

export default notificationSlice.reducer;